<template>
  <div
    class="draggable-div"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
  >
    <slot />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'DraggableDiv',
  emits: ['drag-left', 'drag-right'],
  setup(_, { emit }) {

    const touchStartX: Ref<number> = ref(0);

    const handleTouchStart = (event: TouchEvent) => {

      touchStartX.value = event.touches[0].clientX;
    
    };

    const handleTouchMove = (event: TouchEvent) => {

      if (!touchStartX.value) {

        return;

      }
      const touchEndX: number = event.touches[0].clientX;
      const touchDiff: number = touchStartX.value - touchEndX;

      if (touchDiff > 0) {

        emit('drag-right');
      
      } else {

        emit('drag-left');
      
      }
      touchStartX.value = 0;
    
    };

    return {
      handleTouchStart,
      handleTouchMove,
    };
  
  },
});

</script>
